export default "__VITE_ASSET__Cv3EnRm8__"